import { ELanguage } from 'interfaces/common';

import en from './en.locale';
import de from './de.locale';

export const locales = {
  [ELanguage.en]: en,
  [ELanguage.de]: de,
};
